import React from 'react';

import { Crown } from '@apigrowfinance/pbolt-icons';
import Tag from '@apigrowfinance/pbolt-tag';
import { FormattedMessage } from 'react-intl';

const AccountHolderChip = () => (
    <Tag
        label={
            <FormattedMessage
                id="AccountHolderChip.accountHolder"
                defaultMessage="Account Holder"
            />
        }
        icon={<Crown fontSize="inherit" />}
        color="default"
        filled
    />
);

export default AccountHolderChip;
